import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 bg-mystic-950 border-t border-mystic-800 text-center" data-id="element-48">
      <p className="text-gray-500 text-sm" data-id="element-49">
        © 2026 Sistema Pro Registros Akáshicos. Todos los derechos reservados.
      </p>
    </footer>;
}